import React, { createContext, FC, useContext, useState } from 'react';

type ClientSecretContextType = {
  clientSecret?: string;
  setClientSecret: (secret: string) => void;
};

const ClientSecretContext = createContext<ClientSecretContextType | undefined>(undefined);

export const ClientSecretProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [clientSecret, setClientSecret] = useState<string>();

  return (
    <ClientSecretContext.Provider value={{ clientSecret, setClientSecret }}>{children}</ClientSecretContext.Provider>
  );
};

export function useClientSecret() {
  const context = useContext(ClientSecretContext);
  if (!context) throw new Error('useClientSecret must be used within a ClientSecretProvider');
  return context;
}
